import React = require("react");
import {CardBox} from "../../../components/CardBox";
import {Title} from "../../../components/Title";
import {PrettyPrinter} from "../../../components/Utils/PrettyPrinter";
import {MarketingConfig, UNITS_UNIT_OF_MEASURE_CODE} from "../data/MarketingConfig";
import UnitOfMeasure = MarketingConfig.UnitOfMeasure;
import {MarketingData} from "../data/MarketingData";
import "./MarketingSalesWidget.scss";
import MarketingDataConverter = MarketingData.MarketingDataConverter;
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {Display} from "../../../components/Display";

interface Sale {
    title: string;
    quantity: number;
    unitOfMeasure: string;
}

interface MarketingSalesWidgetProps {
    period?: string;
    rollingPeriod: string;
    yearAgoPeriod?: string;
    title: string;
    titleSalesTotals: string;
    titleLocationAverage: string;
    titleSelectionAverage: string;
    titleEquipmentAverage: string;
    unitOfMeasure: UnitOfMeasure;
    sales?: Sale;
    salesRollingPeriod: Sale;
    salesYearAgo?: Sale;
    locationAvg?: Sale;
    selectionAvg?: Sale;
    equipmentAvg?: Sale;
    locationAvgRollingPeriod: Sale;
    selectionAvgRollingPeriod: Sale;
    equipmentAvgRollingPeriod: Sale;
    locationAvgYearAgo?: Sale;
    selectionAvgYearAgo?: Sale;
    equipmentAvgYearAgo?: Sale;
}

export const MarketingSalesWidget: React.SFC<MarketingSalesWidgetProps> = (props) => {

    /** Background color for the total sales card box. */
    const SALES_TOTALS_COLOR: string = "rgba(24, 138, 226, 0.2)";
    /** Background color for the average sales card box. */
    const SALES_AVG_COLOR: string = "rgba(67, 167, 69, 0.2)";

    let salesTotals;
    {
        const title = props.titleSalesTotals;
        let value: string;
        let footer: string = null;
        if (props.sales) {
            value = PrettyPrinter.salesQuantity(props.sales.quantity, props.sales.unitOfMeasure);
            footer =
                props.rollingPeriod + ": " +
                PrettyPrinter.salesQuantity(props.salesRollingPeriod.quantity, props.salesRollingPeriod.unitOfMeasure);
        } else {
            value = PrettyPrinter.salesQuantity(
                props.salesRollingPeriod.quantity,
                props.salesRollingPeriod.unitOfMeasure,
            );
        }
        salesTotals = (
            <div className="row__container">
                <CardBox
                    title={title}
                    value={value}
                    footer={footer}
                    backgroundColor={SALES_TOTALS_COLOR}
                />
            </div>
        );
    }
    let locationAvg;
    {
        const title: string = props.titleLocationAverage;
        let value: string;
        let valueUp: boolean = null;
        let footer = null;
        if (props.locationAvg) {
            value = PrettyPrinter.salesQuantity(props.locationAvg.quantity, props.locationAvg.unitOfMeasure);
            const valueDiff = props.locationAvg.quantity - props.locationAvgRollingPeriod.quantity;
            if (valueDiff > 0) {
                valueUp = true;
            } else if (valueDiff < 0) {
                valueUp = false;
            }
            footer =
                props.rollingPeriod + ": " +
                PrettyPrinter.salesQuantity(
                    props.locationAvgRollingPeriod.quantity,
                    props.locationAvgRollingPeriod.unitOfMeasure,
                );

        } else {
            value = PrettyPrinter.salesQuantity(
                props.locationAvgRollingPeriod.quantity,
                props.locationAvgRollingPeriod.unitOfMeasure,
            );
        }
        locationAvg = (
            <div className="row__container">
                <CardBox
                    title={title}
                    value={value}
                    valueUp={valueUp}
                    footer={footer}
                    backgroundColor={SALES_AVG_COLOR}
                />
            </div>
        );
    }
    let selectionAvg;
    {
        const title: string = props.titleSelectionAverage;
        let value: string;
        let valueUp: boolean = null;
        let footer: string = null;
        if (props.selectionAvg) {
            value = PrettyPrinter.salesQuantity(props.selectionAvg.quantity, props.selectionAvg.unitOfMeasure);
            const valueDiff = props.selectionAvg.quantity - props.selectionAvgRollingPeriod.quantity;
            if (valueDiff > 0) {
                valueUp = true;
            } else if (valueDiff < 0) {
                valueUp = false;
            }
            footer =
                props.rollingPeriod + ": " +
                PrettyPrinter.salesQuantity(
                    props.selectionAvgRollingPeriod.quantity,
                    props.selectionAvgRollingPeriod.unitOfMeasure,
                );
        } else {
            value = PrettyPrinter.salesQuantity(
                props.selectionAvgRollingPeriod.quantity,
                props.selectionAvgRollingPeriod.unitOfMeasure,
            );
        }
        selectionAvg = (
            <div className="row__container">
                <CardBox
                    title={title}
                    value={value}
                    valueUp={valueUp}
                    footer={footer}
                    backgroundColor={SALES_AVG_COLOR}
                />
            </div>
        );
    }
    let equipmentAvg;
    {
        if (props.equipmentAvg || props.equipmentAvgRollingPeriod) {
            const title: string = props.titleEquipmentAverage;
            let value: string;
            let valueUp: boolean = null;
            let footer: string = null;
            if (props.equipmentAvg) {
                value = PrettyPrinter.salesQuantity(props.equipmentAvg.quantity, props.equipmentAvg.unitOfMeasure);
                const valueDiff = props.equipmentAvg.quantity - props.equipmentAvgRollingPeriod.quantity;
                if (valueDiff > 0) {
                    valueUp = true;
                } else if (valueDiff < 0) {
                    valueUp = false;
                }
                footer =
                    props.rollingPeriod + ": " +
                    PrettyPrinter.salesQuantity(
                        props.equipmentAvgRollingPeriod.quantity,
                        props.equipmentAvgRollingPeriod.unitOfMeasure,
                    );
            } else {
                value = PrettyPrinter.salesQuantity(
                    props.equipmentAvgRollingPeriod.quantity,
                    props.equipmentAvgRollingPeriod.unitOfMeasure,
                );
            }
            equipmentAvg = (
                <div className="row__container">
                    <CardBox
                        title={title}
                        value={value}
                        valueUp={valueUp}
                        footer={footer}
                        backgroundColor={SALES_AVG_COLOR}
                    />
                </div>
            );
        } else {
            equipmentAvg = null;
        }
    }
    return (
        <VeBoxCard className="marketing-widget marketing-widget-2x2 marketing-widget-sales no-margin">
            <VeBoxCard.Header title={props.title}/>
            <VeBoxCard.Body className="marketing-widget__content marketing-sales-widget">
                <div className={"marketing-sales-widget__row"}>
                    {salesTotals}
                </div>
                <div className={"marketing-sales-widget__row"}>
                    {locationAvg}
                </div>
                <Display isVisible={equipmentAvg != null}>
                    <div className={"marketing-sales-widget__row"}>
                        {equipmentAvg}
                    </div>
                </Display>
                <Display isVisible={!MarketingDataConverter.isUnitsUnitOfMeasure(props.unitOfMeasure)}>
                    <div className={"marketing-sales-widget__row"}>
                        {selectionAvg}
                    </div>
                </Display>
            </VeBoxCard.Body>
        </VeBoxCard>
    );
};
